<form #noteForm="ngForm" (ngSubmit)="onSubmit(noteForm)" class="md-form mt-0 mb-0">
  <div class="d-sm-flex" style="justify-content: space-between">
    <div class="form-outline">
      <textarea
        type="text"
        id="notes"
        class="md-textarea form-control pt-0 pb-0"
        name="notes"
        placeholder="Add a note"
        #noteModel="ngModel"
        [(ngModel)]="noteText"
        mdbInput
        mdbValidate
        required
      ></textarea>
      <mdb-error id="noteError" *ngIf="noteModel.invalid && (noteModel.dirty || noteModel.touched)">You can't save an empty note</mdb-error>
    </div>
    <app-loading [busy]="noteSaving"></app-loading>
    <ng-container *ngIf="!noteSaving">
      <button type="submit" mdbBtn color="trakly-action" class="relative waves-light btn-sm btn">Save</button>
    </ng-container>
  </div>
</form>
